import axios from 'axios';
import { message } from 'antd';

// 创建axios实例
const axiosInstance = axios.create();

// 响应拦截器：统一处理401/403错误
axiosInstance.interceptors.response.use(
  (response) => {
    // 正常响应直接返回
    return response;
  },
  (error) => {
    // 处理错误响应
    if (error.response) {
      const { status } = error.response;
      
      // 处理401/403认证错误
      if (status === 401 || status === 403) {
        message.error('登录已过期，请重新登录');
        
        // 清除token
        localStorage.removeItem('token');
        
        // 跳转到登录页
        window.location.href = '/login';
        
        // 阻止错误继续传播
        return Promise.reject(new Error('Authentication failed'));
      }
    }
    
    // 其他错误继续传播
    return Promise.reject(error);
  }
);

export default axiosInstance;
